import React from "react";
import {Icon} from "./Icon.jsx";

export function Tag({selected=false,onRemove,children,style,...rest}){
  const [hover,setHover]=React.useState(false);
  return (
    <span onMouseEnter={()=>setHover(true)} onMouseLeave={()=>setHover(false)}
      style={{display:"inline-flex",alignItems:"center",gap:"6px",height:"28px",padding:"0 10px",
        borderRadius:"var(--radius-pill)",fontFamily:"var(--font-body)",fontSize:"var(--text-xs)",
        fontWeight:"var(--weight-medium)",whiteSpace:"nowrap",transition:"var(--transition-control)",
        background:selected?"var(--surface-brand)":"transparent",
        color:selected?"var(--fg-invert)":"var(--fg-2)",
        border:selected?"1px solid var(--surface-brand)":"1px solid var(--line-default)",
        ...(hover&&!selected?{borderColor:"var(--line-strong)",color:"var(--fg-1)"}:null),
        ...style}} {...rest}>
      {children}
      {onRemove&&<button onClick={onRemove} aria-label="Quitar" style={{all:"unset",cursor:"pointer",display:"inline-flex",opacity:.7}}><Icon name="x" size={12} strokeAlign="middle"/></button>}
    </span>
  );
}
